import { useContext } from 'preact/hooks'
import { FormContextValue, FormContext } from './FormContext'

export const useFormContext = (): FormContextValue | null => useContext(FormContext)
